var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"courses-card"},[_c('TextCard',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("診療科目")]},proxy:true},{key:"content",fn:function(){return [_c('p',[_vm._v("整形外科 リウマチ科 リハビリテーション科")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }